import React, { useState } from 'react';

const LicensingInfo = () => {
  const [activeProblem, setActiveProblem] = useState(0);

  const credentials = [
    {
      question: "FMCSA Licensed & Registered Broker",
      answer: "Trackline XR operates under active FMCSA authority with an official Motor Carrier (MC) number, ensuring compliance with federal transportation regulations."
    },
    {
      question: "USDOT Registration",
      answer: "We are registered with the U.S. Department of Transportation for nationwide brokerage and carrier operations."
    },
    {
      question: "Surety Bond Coverage",
      answer: "Backed by the federally required $75,000 BMC-84 bond, giving clients peace of mind that all transactions are financially protected."
    },
    {
      question: "Insurance",
      answer: "Comprehensive contingent cargo and general liability insurance to safeguard your freight against unforeseen risks."
    }
  ];

  const benefits = [
    {
      title: "Risk-Free Partnering",
      description: "Our compliance guarantees that your freight is handled only by vetted, qualified carriers meeting FMCSA safety standards."
    },
    {
      title: "Regulatory Confidence",
      description: "From customs filings to domestic freight moves, you can trust every step aligns with DOT, FMCSA, and U.S. trade regulations."
    },
    {
      title: "Financial Security",
      description: "With active bonding and insurance, your shipments and payments are protected."
    },
    {
      title: "Audit-Ready Documentation",
      description: "We maintain proper contracts, bills of lading, and proof of compliance, making your supply chain smoother and worry-free."
    }
  ];

  return (
    <div className="licensing-compliance">
      {/* Hero Section */}
      <section className="hero-section hero-margin">
        <div className="hero-overlay">
          <div className="container">
            <div className="hero-content">
              <h1>Licensing & Compliance Information</h1>
              <p className="hero-tagline">At Trackline XR, compliance is at the core of everything we do.</p>
              <p className="hero-subtitle">
                Freight brokerage and transportation in the U.S. is highly regulated, and we believe our clients deserve full transparency when it comes to the licenses, certifications, and security measures that protect their shipments.
              </p>
             
            </div>
          </div>
        </div>
      </section>

      {/* Credentials Section - Automotive Style */}
      <section className="problems-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Credentials</h2>
            <p>Fully licensed and compliant with all federal regulations</p>
          </div>
          
          <div className="problems-grid">
            {credentials.map((credential, index) => (
              <div 
                key={index}
                className={`problem-box ${activeProblem === index ? 'active' : ''}`}
                onMouseEnter={() => setActiveProblem(index)}
              >
                <div className="problem-question">
                  <div className="question-icon">
                    <span>{index + 1}</span>
                  </div>
                  <h3>{credential.question}</h3>
                </div>
                <div className="problem-answer">
                  <p>{credential.answer}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="solution-display">
            <div className="solution-content">
              <div>
                <h3>Our Credentials</h3>
                <p>{credentials[activeProblem].answer}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <div className="section-header">
            <h2>Why This Matters for You</h2>
            <p>Protecting your business with comprehensive compliance measures</p>
          </div>
          
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-number">
                  <span>{index + 1}</span>
                </div>
                <div className="benefit-content">
                  <h3>{benefit.title}</h3>
                  <p>{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Value Section */}
      <section className="partnership-section">
        <div className="container">
          <div className="partnership-content">
            <div className="partnership-image">
              <img 
               src={`${process.env.PUBLIC_URL}/assets/images/bg/subpage-lic-section.avif`}
                alt="Compliance and Security" 
              />
            </div>
            <div className="partnership-text">
              <h2>Licensing & Compliance</h2>
              <h3>Value Beyond Compliance</h3>
              <p>Licensing isn't just paperwork — it's about creating a trustworthy logistics ecosystem. At Trackline XR, we combine regulatory compliance with technology-driven monitoring, ensuring every shipment is transparent, secure, and delivered in line with U.S. standards.</p>
              
              <div className="value-points">
                <div className="value-point">
                  <div className="point-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                      <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                  </div>
                  <span>Technology-Driven Monitoring</span>
                </div>
                <div className="value-point">
                  <div className="point-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                    </svg>
                  </div>
                  <span>Secure & Protected Operations</span>
                </div>
                <div className="value-point">
                  <div className="point-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                  </div>
                  <span>Full Transparency & Visibility</span>
                </div>
              </div>
              
              
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .licensing-compliance {
          font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          color: #333;
          line-height: 1.6;
          overflow-x: hidden;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .text-center {
          text-align: center;
        }

        .mt-5 {
          margin-top: 3rem;
        }

        /* Hero Section */
  .hero-section {
  background: #00358d;
  background-position: center;
  background-attachment: scroll;
  color: white;
  padding: 110px 0;
  position: relative;
}
        .hero-margin {
          margin-left: 20px;
          margin-right: 20px;
          border-radius: 20px;
        }

        .hero-overlay {
          position: relative;
          z-index: 2;
        }

        .hero-content {
          text-align: center;
          max-width: 800px;
          margin: 0 auto;
        }

        .hero-content h1 {
  font-size: 4rem;
  line-height: 4rem;
 color: white;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 3px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  margin-top: 7rem;
}

        .hero-tagline {
          font-size: 1.8rem;
          margin-bottom: 1rem;
          font-weight: 500;
          opacity: 0.95;
        }

        .hero-subtitle {
          font-size: 1.3rem;
          margin-bottom: 2.5rem;
          opacity: 0.9;
          max-width: 600px;
          margin-left: auto;
          margin-right: auto;
        }

        /* CTA Button */
        .cta-button {
          background: linear-gradient(135deg, #e30613, #c10510);
          color: white;
          border: none;
          padding: 16px 45px;
          font-size: 1.1rem;
          border-radius: 30px;
          cursor: pointer;
          transition: all 0.3s ease;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 1px;
          box-shadow: 0 4px 15px rgba(227, 6, 19, 0.3);
          position: relative;
          overflow: hidden;
        }

        .cta-button:hover {
          transform: translateY(-3px);
          box-shadow: 0 6px 20px rgba(227, 6, 19, 0.4);
          background: linear-gradient(135deg, #c10510, #a0040d);
        }

        .cta-button:active {
          transform: translateY(-1px);
        }

        /* Problems Section */
        .problems-section {
          padding: 100px 0;
          background-color: #f8fafc;
        }

        .section-header {
          text-align: center;
          margin-bottom: 60px;
        }

        .section-header h2 {
          font-size: 2.8rem;
          margin-bottom: 1.5rem;
          color: #1a202c;
          font-weight: 700;
          position: relative;
          display: inline-block;
        }

        .section-header h2:after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 4px;
          background: linear-gradient(135deg, #e30613, #c10510);
          border-radius: 2px;
        }

        .section-header p {
          font-size: 1.3rem;
          color: #666;
          max-width: 700px;
          margin: 0 auto;
          line-height: 1.7;
        }

        .problems-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 30px;
          margin-bottom: 50px;
        }

        .problem-box {
          background: white;
          border-radius: 12px;
          padding: 30px;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
          transition: all 0.4s ease;
          cursor: pointer;
          border-left: 5px solid transparent;
          min-height: 180px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
          overflow: hidden;
        }

        .problem-box:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, rgba(227, 6, 19, 0.03), rgba(193, 5, 16, 0.03));
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .problem-box:hover {
          transform: translateY(-8px);
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
        }

        .problem-box:hover:before {
          opacity: 1;
        }

        .problem-box.active {
          border-left: 5px solid #e30613;
          background-color: #fff5f5;
          transform: translateY(-8px);
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
        }

        .problem-box.active:before {
          opacity: 1;
        }

        .problem-question {
          display: flex;
          align-items: flex-start;
          gap: 20px;
        }

        .question-icon {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #e30613, #c10510);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          color: white;
          font-weight: 700;
          font-size: 1.1rem;
          box-shadow: 0 4px 10px rgba(227, 6, 19, 0.3);
        }

        .problem-question h3 {
          font-size: 1.3rem;
          margin: 0;
          color: #1a202c;
          font-weight: 600;
          line-height: 1.5;
        }

        .problem-answer {
          margin-top: 20px;
          padding-top: 20px;
          border-top: 1px solid #e2e8f0;
          display: none;
        }

        .problem-box.active .problem-answer {
          display: block;
          animation: fadeInUp 0.5s ease;
        }

        @keyframes fadeInUp {
          from { 
            opacity: 0; 
            transform: translateY(10px); 
          }
          to { 
            opacity: 1; 
            transform: translateY(0); 
          }
        }

        .problem-answer p {
          margin: 0;
          color: #e30613;
          font-weight: 500;
          font-size: 1.1rem;
          line-height: 1.6;
        }

        .solution-display {
          background: white;
          border-radius: 15px;
          padding: 40px;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
          margin-bottom: 40px;
          border-top: 5px solid #e30613;
          position: relative;
          overflow: hidden;
        }

        .solution-display:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, rgba(227, 6, 19, 0.02), rgba(193, 5, 16, 0.02));
        }

        .solution-content {
          display: flex;
          align-items: flex-start;
          gap: 25px;
          position: relative;
          z-index: 2;
        }

        .solution-content h3 {
          color: #e30613;
          margin-bottom: 15px;
          font-size: 1.8rem;
          font-weight: 700;
        }

        .solution-content p {
          font-size: 1.4rem;
          margin: 0;
          color: #1a202c;
          font-weight: 500;
          line-height: 1.6;
        }

        /* Benefits Section */
        .benefits-section {
          padding: 100px 0;
          background-color: white;
        }

        .benefits-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 30px;
        }

        .benefit-card {
          display: flex;
          align-items: flex-start;
          gap: 20px;
          background: #f8fafc;
          border-radius: 12px;
          padding: 30px;
          transition: all 0.3s ease;
        }

        .benefit-card:hover {
          background: white;
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          transform: translateY(-3px);
        }

        .benefit-number {
          width: 50px;
          height: 50px;
          background: linear-gradient(135deg, #e30613, #c10510);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 700;
          font-size: 1.2rem;
          flex-shrink: 0;
        }

        .benefit-content h3 {
          font-size: 1.3rem;
          margin-bottom: 10px;
          color: #1a202c;
          font-weight: 600;
        }

        .benefit-content p {
          color: #666;
          line-height: 1.6;
          margin: 0;
        }

        /* Partnership Section */
        .partnership-section {
          padding: 100px 0;
          background-color: white;
        }

        .partnership-content {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 60px;
          align-items: center;
        }

        .partnership-image {
          border-radius: 15px;
          overflow: hidden;
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
          transition: transform 0.4s ease;
        }

        .partnership-image:hover {
          transform: scale(1.02);
        }

        .partnership-image img {
          width: 100%;
          height: 500px;
          object-fit: cover;
          display: block;
        }

        .partnership-text {
          padding-left: 20px;
        }

        .partnership-text h2 {
          font-size: 1.8rem;
          margin-bottom: 0.5rem;
          color: #666;
          text-transform: uppercase;
          letter-spacing: 3px;
          font-weight: 600;
        }

        .partnership-text h3 {
          font-size: 2.8rem;
          margin-bottom: 1.5rem;
          font-weight: 800;
          color: #1a202c;
          text-transform: uppercase;
          letter-spacing: 1px;
          position: relative;
          display: inline-block;
        }

        .partnership-text h3:after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 0;
          width: 80px;
          height: 4px;
          background: linear-gradient(135deg, #e30613, #c10510);
          border-radius: 2px;
        }

        .partnership-text p {
          font-size: 1.2rem;
          margin-bottom: 1.5rem;
          line-height: 1.7;
          color: #4a5568;
        }

        .value-points {
          display: flex;
          flex-direction: column;
          gap: 20px;
          margin-bottom: 30px;
        }

        .value-point {
          display: flex;
          align-items: center;
          gap: 15px;
        }

        .point-icon {
          width: 40px;
          height: 40px;
          background: #e30613;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          flex-shrink: 0;
        }

        .point-icon svg {
          width: 20px;
          height: 20px;
        }

        .value-point span {
          font-weight: 600;
          color: #1a202c;
        }

        .partnership-text .cta-button {
          margin-top: 10px;
        }

        /* Responsive Design */
        @media (max-width: 992px) {
          .problems-grid,
          .benefits-grid {
            grid-template-columns: 1fr;
            gap: 25px;
          }
          
          .partnership-content {
            grid-template-columns: 1fr;
            gap: 40px;
          }
          
          .partnership-text {
            padding-left: 0;
            text-align: center;
          }
          
          .partnership-text h3:after {
            left: 50%;
            transform: translateX(-50%);
          }
          
          .hero-content h1 {
            font-size: 3.2rem;
          }
          
          .partnership-text h3 {
            font-size: 2.4rem;
          }
        }

        @media (max-width: 768px) {
          .hero-section {
            padding: 80px 0;
            background-attachment: scroll;
          }
          
          .hero-content h1 {
            font-size: 2.5rem;
          }
          
          .hero-tagline {
            font-size: 1.5rem;
          }
          
          .section-header h2 {
            font-size: 2.2rem;
          }
          
          .problems-section,
          .benefits-section,
          .partnership-section {
            padding: 70px 0;
          }
          
          .problem-box {
            padding: 25px;
            min-height: 160px;
          }
          
          .problem-question h3 {
            font-size: 1.2rem;
          }
          
          .solution-display {
            padding: 30px;
          }
          
          .solution-content {
            flex-direction: column;
            text-align: center;
            gap: 20px;
          }
          
          .solution-content h3 {
            font-size: 1.6rem;
          }
          
          .solution-content p {
            font-size: 1.2rem;
          }
          
          .benefit-card {
            flex-direction: column;
            text-align: center;
          }
          
          .partnership-text h2 {
            font-size: 1.5rem;
          }
          
          .partnership-text h3 {
            font-size: 2rem;
          }
          
          .partnership-text p {
            font-size: 1.1rem;
          }
          
          .value-points {
            align-items: center;
          }
        }

        @media (max-width: 480px) {
          .container {
            padding: 0 15px;
          }
          
          .hero-content h1 {
            font-size: 2rem;
          }
          
          .hero-tagline {
            font-size: 1.2rem;
          }
          
          .hero-subtitle {
            font-size: 1.1rem;
          }
          
          .cta-button {
            padding: 14px 35px;
            font-size: 1rem;
          }
          
          .section-header h2 {
            font-size: 1.8rem;
          }
          
          .section-header p {
            font-size: 1.1rem;
          }
          
          .problem-question {
            flex-direction: column;
            gap: 15px;
            text-align: center;
          }
          
          .partnership-image img {
            height: 350px;
          }
        }
      `}</style>
    </div>
  );
};

export default LicensingInfo;